import React, { Component } from "react";
import { switchReportStyle } from "../../Reports/Timps/Switch/style";
import { blueCardSections } from "./Schema";
import { blueCardRailCarSections } from "./SchemaRailCar";
import { extractPeriods } from "./SchemaHelpers";
import ReportTitleSection from "../../../libraries/ReportGenerator/ReportTitleSection";
import ReportTableSectionRenderer from "../../../libraries/ReportGenerator";
import { themeService } from "../../../theme/service/activeTheme.service";
import BlueCardHeader from "./BlueCardHeader/BllueCardHeader";
import { formatDate } from "../../Reports/ReVAMP/NonComplaintMaintanence/NonComplaintMaintanence";
import "./BlueCard.css";
import { blueCardMethods } from "./HelperMethods";
import { dataFormatters } from "../../../utils/dataFormatters";
import CertifyContainer from "./CertifyTest/CertifyContainer";
import LocomotiveHeaderRailCar from "./BlueCardHeader/BllueCardHeaderRailCar";
import _ from "lodash";
const flexStyle = { display: "flex", justifyContent: "center", alignItems: "center" };

const GetInnerTextOfNotesBox = {
  Noise: (summary) => {
    let text = [];
    const { GandOHornTestPerformed } = summary || {};
    if (GandOHornTestPerformed) {
      extractPeriods(summary.GandOHornTestPerformed).map((e) => {
        let formData = summary.GandOHornTestPerformed[`${e}FormData`];
        let formDate = summary.GandOHornTestPerformed[`${e}Date`];
        if (formData && formDate) {
          text.push(
            <li style={{ padding: "5px" }} className="blueCardFooterInstructionsBox">
              HORN TEST PERFORMED {dataFormatters.dateFormatter(formDate)}
              {formData && formData.com && `: ${formData.com}`}
            </li>,
          );
        }
      });
      if (GandOHornTestPerformed && !GandOHornTestPerformed.period1Id) {
        let formData = summary.GandOHornTestPerformed[`prevFormData`];
        let formDate = summary.GandOHornTestPerformed[`prevDate`];
        if (formData && formDate) {
          text.push(
            <li style={{ padding: "5px" }} className="blueCardFooterInstructionsBox">
              HORN TEST PERFORMED {dataFormatters.dateFormatter(formDate)}
              {formData && formData.com && `: ${formData.com}`}
            </li>,
          );
        }
      }
    }

    return text;
  },
  Repairs: (summary) => {
    let text = [];
    let index = 1;
    if (summary && summary.nonCompliantBackToService) {
      extractPeriods(summary.nonCompliantBackToService).map((e) => {
        let formData = summary.nonCompliantBackToService[`${e}FormData`];
        let formDate = summary.nonCompliantBackToService[`${e}Date`];
        if (formData && formData.comments) {
          text.push(
            <span style={{ padding: "5px" }} className="blueCardFooterInstructionsBox">
              {formatDate(formDate)} - {formData.comments}
              <br />
            </span>,
          );
          index++;
        }
      });
    }
    return text;
  },

  Remarks: (summary) => {
    let text = [];
    const { waiverType } = summary || {};
    if (waiverType) {
      extractPeriods(summary.waiverType).map((e) => {
        let formData = summary.waiverType[`${e}FormData`];
        if (formData && formData.comments) {
          text.push(`FRA WAIVER #${formData.waivernumber} (${formData.comments}).`);
        }
      });
    }

    const { GandOReflectiveStripingReplacement } = summary || {};
    if (GandOReflectiveStripingReplacement) {
      extractPeriods(summary.GandOReflectiveStripingReplacement).map((e) => {
        let formData = summary.GandOReflectiveStripingReplacement[`${e}FormData`];
        let formDate = summary.GandOReflectiveStripingReplacement[`${e}Date`];
        if (formData && formDate) {
          text.push(
            `REFLECTIVE STRIPING INSTALLED ${dataFormatters.dateFormatter(formDate)}${formData && formData.com ? `: ${formData.com}` : ""}`,
          );
        }
      });
      if (GandOReflectiveStripingReplacement && !GandOReflectiveStripingReplacement.period1Id) {
        let formData = summary.GandOReflectiveStripingReplacement[`prevFormData`];
        let formDate = summary.GandOReflectiveStripingReplacement[`prevDate`];
        if (formData && formDate) {
          text.push(
            `REFLECTIVE STRIPING INSTALLED ${dataFormatters.dateFormatter(formDate)}${formData && formData.com ? `: ${formData.com}` : ""}`,
          );
        }
      }
    }

    let outOfUseRemarks = summary && summary.OutOfUse && summary.OutOfUse.remarks;
    if (outOfUseRemarks) {
      outOfUseRemarks.forEach((remark) => {
        let start = remark.start;
        let end = remark.end;
        let diff = blueCardMethods.calculateOOUDays(start, end);
        if (diff >= 30) {
          text.push(
            `Out of Use: ${dataFormatters.dateFormatter(start)} until ${dataFormatters.dateFormatter(
              end,
            )} (${blueCardMethods.calculateOOUDays(start, end)} Days)`,
          );
        }
      });
    }

    return text.join(", ");
  },
};
class BlueCardReportView extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }
  render() {
    let data = this.props.reportData && this.props.reportData.summary;
    data = blueCardMethods.processSummaryForPeriodic(data);
    let Forms = this.props.reportData && this.props.reportData.summary;
    let assetAttributes = this.props.reportData && this.props.reportData.asset && this.props.reportData.asset.attributes;
    let assetId = null;

    if (this.props.reportData && this.props.reportData.asset && this.props.reportData.asset._id) {
      assetId = this.props.reportData.asset._id.toString();
    }

    data = {
      ...data,
      reportYear: this.props.year,
      ...assetAttributes,
      assetId,
    };

    let blueCardSectionsLookupObj =
      (this.props.blueCardSectionsLookups &&
        this.props.blueCardSectionsLookups.reduce((result, lookup) => {
          result[lookup.code] = lookup.opt1;
          return result;
        }, {})) ||
      {};

    return this.props.reportData && this.props.reportData.asset && this.props.reportData.asset.assetType === "Transit Rail Car" ? (
      <BlueCardReportViewRailCar
        {...this.props}
        blueCardSectionsLookupObj={blueCardSectionsLookupObj}
        Forms={Forms}
        data={data}
        assetAttributes={assetAttributes}
        assetId={assetId}
      />
    ) : (
      <BlueCardReportViewLoco
        {...this.props}
        blueCardSectionsLookupObj={blueCardSectionsLookupObj}
        Forms={Forms}
        data={data}
        assetAttributes={assetAttributes}
        assetId={assetId}
      />
    );
  }
}

function instructionsRenderer(number, title, text) {
  return (
    <div style={{ ...flexStyle, padding: "0px 50px", alignItems: "flex-start", justifyContent: "start" }}>
      <div className="blueCardFooterInstructionsTitle" style={{ minWidth: "40px" }}>
        {number}
      </div>
      <div>
        <span className="blueCardFooterInstructionsTitle" style={{ fontSize: "14px", textDecoration: "underline" }}>
          {title}:
        </span>
        <span className="blueCardFooterInstructionsText" style={{ fontSize: "13px" }}>
          {" "}
          {text}
        </span>
      </div>
    </div>
  );
}
function instructionsRendererRailCar(title, text) {
  return (
    <div style={{ ...flexStyle, alignItems: "flex-start", justifyContent: "start" }}>
      <div>
        <span className="blueCardFooterInstructionsTitle" style={{ fontSize: "14px", textDecoration: "underline" }}>
          <strong>{title}:</strong>
        </span>
        <span className="blueCardFooterInstructionsText" style={{ fontSize: "13px" }}>
          {" "}
          {text}
        </span>
      </div>
    </div>
  );
}

const BlueCardInfoInlineDashed = () => {
  const containerStyle = {
    fontFamily: "Arial, sans-serif",
    fontSize: "14px",
    lineHeight: "1.5",
    color: "#333",
    width: "100%",
  };

  const listItemStyle = {
    display: "flex",
    alignItems: "center",
    marginBottom: "5px",
  };

  const leftTextStyle = {
    whiteSpace: "nowrap",
    paddingRight: "5px",
    fontWeight: 600,
  };

  const dashedLineStyle = {
    flexGrow: 1,
    borderBottom: "1px dashed #000",
    margin: "0 5px",
  };

  const rightTextStyle = {
    whiteSpace: "nowrap",
    paddingLeft: "5px",
    textAlign: "right",
    fontWeight: 600,
  };

  return (
    <div style={containerStyle}>
      <div style={listItemStyle}>
        <span style={leftTextStyle}>229.141 DESIGN REQUIREMENTS (600,000 LBS.)</span>
        <span style={dashedLineStyle}></span>
        <span style={rightTextStyle}>LI-86-6 DOCKET # FRA-2003-16174</span>
      </div>

      <div style={listItemStyle}>
        <span style={leftTextStyle}>229.123 PILOTS SNOWPLOWS AND PLATES THAT WOULD EXTEND ACROSS BOTH RAILS</span>
        <span style={dashedLineStyle}></span>
        <span style={rightTextStyle}>DOCKET # FRA-2008-135</span>
      </div>

      <div style={listItemStyle}>
        <span style={leftTextStyle}>231.14 (A) HANDBRAKES (PARKING BRAKE)</span>
        <span style={dashedLineStyle}></span>
        <span style={rightTextStyle}>DOCKET # FRA-2008-143</span>
      </div>

      <div style={listItemStyle}>
        <span style={leftTextStyle}>231.14 (B, C) SILL STEPS AND SIDE HANDHOLDS</span>
        <span style={dashedLineStyle}></span>
        <span style={rightTextStyle}>DOCKET # FRA-2008-143</span>
      </div>

      <div style={listItemStyle}>
        <span style={leftTextStyle}>231.14 (D) END HANDHOLDS</span>
        <span style={dashedLineStyle}></span>
        <span style={rightTextStyle}>DOCKET # FRA-2008-143</span>
      </div>

      <div style={listItemStyle}>
        <span style={leftTextStyle}>231.14 (E) END HANDRAILS</span>
        <span style={dashedLineStyle}></span>
        <span style={rightTextStyle}>DOCKET # FRA-2008-143</span>
      </div>

      <div style={listItemStyle}>
        <span style={leftTextStyle}>231.14 (F) SIDE DOOR STEPS</span>
        <span style={dashedLineStyle}></span>
        <span style={rightTextStyle}>DOCKET # FRA-2008-143</span>
      </div>

      <div style={listItemStyle}>
        <span style={leftTextStyle}>231.14 (G) UNCOUPLING LEVERS</span>
        <span style={dashedLineStyle}></span>
        <span style={rightTextStyle}>DOCKET # FRA-2008-143</span>
      </div>

      <div style={listItemStyle}>
        <span style={leftTextStyle}>NO CFR REFERENCE# END STEPS</span>
        <span style={dashedLineStyle}></span>
        <span style={rightTextStyle}>DOCKET # FRA-2008-143</span>
      </div>
    </div>
  );
};

function notesBoxRenderer(title, text, innerText) {
  return (
    <div className=" avoid-break-inside-theSection">
      <div>
        <span className="blueCardFooterInstructionsTitle" style={{ fontSize: "14px", textDecoration: "underline" }}>
          {title}:
        </span>
        <span className="blueCardFooterInstructionsText" style={{ fontSize: "13px" }}>
          {" "}
          {text}
        </span>
      </div>
      <div
        className="blueCardFooterInstructionsBox"
        style={{ width: "100%", minHeight: "100px", border: "2px solid black", fontSize: "13px", paddingLeft: "5px" }}
      >
        {innerText}
      </div>
    </div>
  );
}

function BlueCardReportViewLoco(props) {
  const {
    selectedPerformedByUser,
    handlePerformedByUserChange,
    handleCertifyClick,
    pendingReviewDetails,
    blueCardSectionsLookupObj,
    Forms,
    data,
    assetAttributes,
    assetId,
  } = props;
  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      {/* <ReportTitleSection title="Blue Card Report" fontSizeOverride={"35px"} /> */}
      <BlueCardHeader />
      <span className="spacer"></span>
      <table className="table-bordered forMediumScreenSizes" style={{ fontSize: "20px" }}>
        {blueCardSections
          .sections(
            data,
            blueCardSectionsLookupObj,
            selectedPerformedByUser,
            handlePerformedByUserChange,
            handleCertifyClick,
            assetAttributes || {},
          )
          .map((section) => {
            return <ReportTableSectionRenderer section={section} rowsData={data} />;
          })}
      </table>
      <p className="blueCardFooterReport">
        In accordance with the Locomotive Inspection Act, 49 USC Chapter 207 and the regulations issued pursuant to that Act, the parts and
        appurtenances of the locomotive unit have been inspected and all defects disclosed by the inspection have been properly repaired.
      </p>

      <div style={{ ...flexStyle, textAlign: "center", flexDirection: "column" }} className="blueCardFooterReport">
        <span>
          Certification of true copy: I certify that this is a true copy of the inspection and repair record of locomotive no.{" "}
          <span style={{ minWidth: "100px", borderBottom: "1px solid black", display: "inline-block" }}>{data["Loco No"]}</span>
        </span>
        <small>Attention: A false entry on this form is punishable by fine or imprisonment (18 USC Sec1001)</small>
      </div>
      <span className="spacer"></span>
      <div style={{ ...flexStyle, textAlign: "center", gap: "10px" }}>
        <strong style={{ fontSize: "18px" }} className="blueCardFooterOfficerIncharge">
          Officer-in-charge{" "}
        </strong>
        <span style={{ minWidth: "100px", minHeight: "50px", borderBottom: "1px solid black", display: "flex", alignItems: "center" }}>
          <CertifyContainer
            pendingReviewDetails={pendingReviewDetails}
            assetId={assetId}
            certifiedBy={props.reportData && props.reportData.certifiedBy}
            year={props.year}
            handleCertifyClick={handleCertifyClick}
            blueCardReview={props.blueCardReview}
            type="blueCard"
          />
        </span>
        <strong style={{ fontSize: "18px" }} className="blueCardFooterOfficerIncharge">
          Date
        </strong>
        <span style={{ minWidth: "100px", minHeight: "50px", borderBottom: "1px solid black", display: "flex", alignItems: "center" }}>
          {props.reportData && props.reportData.certifiedDate && dataFormatters.dateFormatter(props.reportData.certifiedDate)}
        </span>
      </div>
      <span className="spacer"></span>
      <div className="blueCardFooterReport" style={{ ...flexStyle, justifyContent: "space-between", gap: "10px" }}>
        <strong>Form FRA F6180-49A (11/2012)</strong>
        <span>Government property do not remove.</span>
        <strong>OMB Approval expires 4/30/2025</strong>
      </div>
      <span className="spacer"></span>
      <div className="print-page-break-before">
        <span className="blueCardFooterReport">
          <span className="blueCardFooterInstructions" style={{ textDecoration: "underline" }}>
            INSTRUCTIONS:
          </span>{" "}
          This Locomotive Inspection and Repair Record (Record or F6180-49A) covers a calendar year, except as noted. The Record for the
          preceding calendar year shall be retained in the locomotive until the first periodic inspection of the new year or, until the
          Record is replaced on April 2 or July 3 (if 184 day eligible) as required by 49 CFR 229.23(f) or, until the locomotive changes
          ownership (see 2 below.) Enter the requested information in each block. Special instructions are given below.
        </span>
        {instructionsRenderer(
          "1.",
          "OPERATED BY",
          "Enter the name and code of the primary railroad operating the locomotive at the time this Record is placed in it. Operator changes, including dates, shall be noted in “Remarks.” The “RR Code” is as assigned by FRA to the railroad.",
        )}

        {instructionsRenderer(
          "2.",
          "OWNER",
          "Enter the name and RR Code of the owner. Changes in ownership shall be submitted as final reports.",
        )}

        {instructionsRenderer(
          "3.",
          "LOCOMOTIVE NO.",
          "Enter digits only. Include letters if they differ from the “RR Code.” If renumbered, enter the previous number.",
        )}

        {instructionsRenderer(
          "4.",
          "YEAR BUILT",
          "Enter the year the locomotive was built and check if new. If remanufactured per 49 CFR 229.5, enter “RM” and the year.",
        )}

        {instructionsRenderer(
          "5.",
          "PROPELLED BY",
          "Enter Diesel-Electric (D-E), Electric (E), Electric Multiple Unit (MU), Diesel Multiple Unit (DMU), MU Control Cab (MUC), Non-MU Control Cab (NMUC), Turbine (T), Torque Converter (TC), or Other (O).",
        )}

        {instructionsRenderer("6.", "MAXIMUM PISTON TRAVEL", "Enter only “nominal” travel. Do not include the manufacturer’s tolerance.")}

        {instructionsRenderer(
          "7.",
          "OUT-OF-USE CREDIT",
          "Enter the number of creditable calendar days the locomotive was out-of-use since the last periodic inspection on the previous F6180-49A. Less than 30 consecutive calendar days for any out-of-use period may not be counted per 49 CFR 229.33. For current periods out-of-use, an entry “Out-of-use from _______to_______” shall be made on a Periodic Inspection line and certified when a locomotive which would otherwise be due for inspection is out-of-use. If the locomotive is out of use at the end of the annual reporting period, complete the “To” entry with the last day of the period. An entry shall then be made on the new Record showing the first day of the new reporting period as the “From” date.",
        )}

        {instructionsRenderer(
          "8.",
          "LAST PERIODIC INSPECTION",
          "When a new Record is placed in the locomotive transfer the last periodic inspection information into block 12 a & b and the last test information into column 24 of the new Record. Tests that are not applicable should be noted “NA”.",
        )}

        {instructionsRenderer(
          "9.",
          "AFM CAL.",
          "Enter the date of the last Air Flow Method Indicator (AFM) calibration from the previous year. Enter and certify subsequent calibrations as they are done.",
        )}

        {instructionsRenderer(
          "10.",
          "PERIODIC INSPECTIONS",
          "Check 184 days only if the locomotive qualifies per 49 CFR 229.23(b)(1) and the railroad chooses to abide by the requirement for 33 day QMI Daily inspections, otherwise check 92 days. Persons making the required inspections shall sign and list the item codes inspected. The employee’s supervisor shall certify that the inspections were completed.",
        )}

        {instructionsRenderer(
          "11.",
          "H&H",
          "Enter the test pressure for the hydrostatic air reservoir test. If the reservoirs are drilled, enter “NA” here and “Drilled” in the Hammer and Hydro line below.",
        )}

        {instructionsRenderer(
          "12.",
          "WAIVERS",
          "Any waiver applicable to this locomotive shall be entered by waiver number in block 19 if a waiver from Part 229, or block 20, if a waiver from any other regulation. Enter explanatory information regarding the scope and content of each waiver under “Remarks”.",
        )}

        {instructionsRenderer(
          "13.",
          "TESTS",
          "The maximum number of days for Event Recorder, Level 2 and Level 3 air brake tests shall be entered per the referenced sections of 49 CFR 229. Where the railroad has chosen to fragment air brake clean, repair and test requirements as permitted under 49 CFR 229.29, a separate air record shall be maintained an the cab of the locomotive and the word “Fragmented” shall be entered in the Level 2 and Level 3 lines.",
        )}
        {notesBoxRenderer(
          "REPAIRS",
          "Special notes relating to repairs performed to restore compliance.",
          GetInnerTextOfNotesBox.Repairs(Forms),
        )}
        {notesBoxRenderer(
          "NOISE",
          "Enter any noise tests or related information in accordance with 49 CFR 210.31.",
          GetInnerTextOfNotesBox.Noise(Forms),
        )}
        {notesBoxRenderer("REMARKS", "Additional explanatory or clarifying information.", GetInnerTextOfNotesBox.Remarks(Forms))}

        <span className="spacer"></span>
        <p style={{ fontSize: "13px" }} className="blueCardFooterInstructionsTitle">
          Public reporting burden for this collection of information is estimated to average 15 minutes per response including the time for
          reviewing instructions, searching existing data sources, gathering and maintaining the data needed, and completing and reviewing
          the collection of information. All responses to this collection of information are mandatory. A federal agency may not conduct or
          sponsor, and a person is not required to, nor shall a person be subject to a penalty for failure to comply with, a collection of
          information unless that collection of information displays a current OMB Number. The OMB control number for this information is
          2130- 0004. Anyone with comments regarding this burden estimate or any other aspect of this information collection, including
          suggestions for reducing this burden, may send them to: Information Clearance Officer, Federal Railroad Administration, 1200 New
          Jersey Ave. SE, MS-25, Washington, DC 20590
        </p>
        <div style={{ fontWeight: "bold" }} className="blueCardFooterOfficerIncharge">
          U. S. GOVERNMENT PRINTING OFFICE 2012 461-823/33002
        </div>
        <div style={{ fontWeight: "bold" }} className="blueCardFooterOfficerIncharge">
          Form FRA F6180-49A (11/2012)
        </div>
      </div>
    </div>
  );
}

function BlueCardReportViewRailCar(props) {
  const {
    selectedPerformedByUser,
    handlePerformedByUserChange,
    handleCertifyClick,
    pendingReviewDetails,
    blueCardSectionsLookupObj,
    Forms,
    data,
    assetAttributes,
    assetId,
  } = props;
  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      {/* <ReportTitleSection title="Blue Card Report" fontSizeOverride={"35px"} /> */}
      <LocomotiveHeaderRailCar previousNumber={assetAttributes["Prev No"]} year={props.year} carType={assetAttributes["CAR TYPE"]} />
      {/* <span className="spacer"></span> */}
      <table className="table-bordered forMediumScreenSizes" style={{ fontSize: "20px" }}>
        {blueCardRailCarSections
          .sections(
            data,
            blueCardSectionsLookupObj,
            selectedPerformedByUser,
            handlePerformedByUserChange,
            handleCertifyClick,
            assetAttributes || {},
          )
          .map((section) => {
            return <ReportTableSectionRenderer section={section} rowsData={data} />;
          })}
      </table>
      <div style={{ ...flexStyle, textAlign: "center", flexDirection: "column" }} className="blueCardFooterReport">
        <span>
          Certification of true copy: I certify that this is a true copy of the inspection and repair record of locomotive no.{" "}
          <span style={{ minWidth: "100px", borderBottom: "1px solid black", display: "inline-block" }}>{data["Loco No"]}</span>
        </span>
        <small>Attention: A false entry on this form is punishable by fine or imprisonment (18 U.S.C. Sec. 1001)</small>
      </div>
      <span className="spacer"></span>
      <div style={{ ...flexStyle, textAlign: "center", gap: "10px" }}>
        <strong style={{ fontSize: "18px" }} className="blueCardFooterOfficerIncharge">
          Officer-in-charge{" "}
        </strong>
        <span style={{ minWidth: "100px", minHeight: "50px", borderBottom: "1px solid black", display: "flex", alignItems: "center" }}>
          <CertifyContainer
            pendingReviewDetails={pendingReviewDetails}
            assetId={assetId}
            certifiedBy={props.reportData && props.reportData.certifiedBy}
            year={props.year}
            handleCertifyClick={handleCertifyClick}
            blueCardReview={props.blueCardReview}
            type="blueCard"
          />
        </span>
        <strong style={{ fontSize: "18px" }} className="blueCardFooterOfficerIncharge">
          Date
        </strong>
        <span style={{ minWidth: "100px", minHeight: "50px", borderBottom: "1px solid black", display: "flex", alignItems: "center" }}>
          {props.reportData && props.reportData.certifiedDate && dataFormatters.dateFormatter(props.reportData.certifiedDate)}
        </span>
      </div>
      <span className="spacer"></span>
      <div className="blueCardFooterReport" style={{ ...flexStyle, justifyContent: "space-between", gap: "10px" }}>
        <strong>Form FRA F6180-49A (11/2012)</strong>
        <span>Government property do not remove.</span>
        <strong>OMB Approval No. 2130-0004</strong>
      </div>
      <span className="spacer"></span>
      <div className="print-page-break-before">
        <div style={{ textAlign: "center" }}>
          <span className="blueCardFooterInstructions" style={{ textDecoration: "underline" }}>
            <strong>INSTRUCTIONS</strong>
          </span>
        </div>

        {instructionsRendererRailCar(
          "OPERATED BY",
          'Enter the name and code* of the railroad primarily responsible for operating the locomotive at the time the report is placed in the locomotive. Operator changes, including dates, shall be noted in "Remarks".',
        )}

        {instructionsRendererRailCar(
          "OWNER",
          "Enter the name and code* of the owner. Changes in ownership shall be submitted as final reports.",
        )}
        {instructionsRendererRailCar("MODEL#", "Enter the original builder's model number.")}

        {instructionsRendererRailCar(
          "LOCOMOTIVE #",
          "Enter only the locomotive number. Include letters only if they are part of the locomotive markings. If the locomotive number is changed, include the information at the top of the form.",
        )}

        {instructionsRendererRailCar("YEAR BUILT", "Enter the year the locomotive was built or rebuilt.")}

        {instructionsRendererRailCar(
          "PROPELLED BY",
          " Enter Diesel/Electric (D-E), Electric (E), Mu, Mu Control Cab (MUC), Non-Mu Control Cab (NMUC), Turbo (T), Torque Converter (TC), Other (O).",
        )}

        {instructionsRendererRailCar("HOURSEPOWER", "Enter horsepower rating.")}

        {instructionsRendererRailCar(
          "TYPE OF SERVICE",
          <span>
            Enter type of service the locomotive is assigned to when the report is placed in the locomotive. <br />
            Enter steam generator number(s) and safe working pressure(s). Enter maximum piston travel.
            <br />
            Enter only "nominal" travel and do not include Manufacturer's. Tolerance. Also include type of AIR BRAKE. <br />
            Enter number of creditable calendar days the locomotive was out-of-use. Less than 30 consecutive calendar days for any
            out-of-use period may not be counted. An entry "out-of-use from _______to_______” shall be made on an inspection line and
            certified when a locomotive is not in use when an inspection would otherwise be due. If the locomotive is out-of-use at the end
            of the reporting period, complete the "To" entry with the last day of the period. The entry on the replacement report should
            then record the "From" as the beginning of the new period.
          </span>,
        )}

        {instructionsRendererRailCar(
          "LAST PERIODIC INSPECTION AND TESTS",
          <span>
            This report covers annual periods (January 1 to December 31). The report of the preceding annual period shall be retained in the
            locomotive until the first periodic inspection is made after January 1 of each year or until the form is replaced as required by
            Section 229.23(e). When a new form 6180.49A is placed in the locomotive, enter the last periodic inspection information onto the
            new form in item 12 and the test information in item 24. Tests that are not applicable should be noted "NA".
            <br />
            <div style={{ marginInlineStart: "40px" }}>
              <strong style={{ textDecoration: "underline" }}>INSPECTIONS AND TESTS:</strong> Persons making the required tests and periodic
              inspections shall sign for the items tested or inspected. The employee’s supervisor shall certify that the tests and
              inspections were completed.&nbsp;
              <strong style={{ textDecoration: "underline" }}>TESTS:</strong> Where the carrier has chosen to fragment air brake cleaning,
              repairing and testing required by Sections 229.27 and 29, an air record shall be maintained in the cab of the locomotive.
            </div>
          </span>,
        )}

        {instructionsRendererRailCar(
          "H&H",
          <span>
            Enter test pressure from the hydrostatic test. If reservoirs are drilled, enter word “Drilled”.{" "}
            <strong style={{ textDecoration: "underline" }}>CODE*:</strong> Carriers shall enter only the code assigned by FRA to their
            railroad.
          </span>,
        )}
        <div style={{ fontSize: "13px" }}>
          Any waivers of any type from a requirement of 49 CFR Part 229 shall be identified in block No. 19 by its waiver number or by the
          section number affected. Explanatory information regarding the scope and content of the waiver shall be included under "Remarks".
          <br />
          Any waiver from any FRA requirement other than a requirement of 49 CFR Part 229 shall be identified in block No. 20 by its waiver
          number or by the part and section number affected. Explanatory information regarding the scope and content of the waiver shall be
          incl uded under "Remarks" <br />
          Under Tests <strong>(AIR BRAKE 229.29) </strong>fill in the number of calendar days subject air brake equipment is subjected to
          cleaning, repairing and testing. <br />
        </div>
        {notesBoxRenderer(<b>REPAIRS</b>, " Defects not properly repaired.", GetInnerTextOfNotesBox.Repairs(Forms))}
        {notesBoxRenderer(
          <b>NOISE</b>,
          "ENTER ANY NOISE TESTS OR RELATED INFORMATION IN ACCORDANCE WITH 49 CFR 210.31",
          GetInnerTextOfNotesBox.Noise(Forms),
        )}
        {notesBoxRenderer(
          <b>REMARKS</b>,
          'THE CARRIERS SHOULD ENTER UNDER "REMARKS" ANY OTHER CLARIFYING OR EXPLANATORY INFORMATION',
          GetInnerTextOfNotesBox.Remarks(Forms),
        )}

        <span className="spacer"></span>
        {BlueCardInfoInlineDashed()}
        {/* <div style={{ fontWeight: "bold" }} className="blueCardFooterOfficerIncharge">
        U. S. GOVERNMENT PRINTING OFFICE 2012 461-823/33002
      </div>
      <div style={{ fontWeight: "bold" }} className="blueCardFooterOfficerIncharge">
        Form FRA F6180-49A (11/2012)
      </div> */}
      </div>
    </div>
  );
}

export default BlueCardReportView;



// WEBPACK FOOTER //
// ./src/components/BlueCardReport/BlueCardReportView/index.jsx